const parseShippingType = value => {
  if (typeof value === 'string') {
    try {
      const number = parseInt(value, 10);
      if (String(number) === value) {
        return number;
      }
    } catch (e) {
      console.log(e);
    }
    return value;
  }

  if (typeof value === 'number') {
    return value;
  }

  // TODO throw exception?
  return value;
};

export default parseShippingType;
